'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'cat';
var width = 576;
var height = 512;
var aliases = [128008];
var unicode = 'f6be';
var svgPathData = ['M128 424c0-105.3 72.2-195.8 172.8-220.5C323.5 253.4 373.7 288 432 288c5.4 0 10.7-.3 16-.7l-25.8 20.1L304 399.3l0-7.3c0-39.8-32.2-72-72-72l-8 0-16 0 0 32 16 0 8 0c22.1 0 40 17.9 40 40l0 24 0 16 0 16 16 0 37.3 0c14.7 0 26.7 11.9 26.7 26.7l0 5.3-48 0-128 0-48 0 0-56zM352 32l1.4 0 43.3 43.3 4.7 4.7 6.6 0 48 0 6.6 0 4.7-4.7L510.6 32l1.4 0 0 112c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-112zm32 96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 159.3c11.3-1.4 21.9-3.9 32-7.5L480 480l-32 0 0-160 0-32.7z', 'M336 0l24 0 6.6 0 4.7 4.7L414.6 48l34.7 0L492.7 4.7 497.4 0 504 0l24 0 16 0 0 16 0 128c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-128 0-16 16 0zm16 144c0 44.2 35.8 80 80 80s80-35.8 80-80l0-112-1.4 0L467.3 75.3 462.6 80 456 80l-48 0-6.6 0-4.7-4.7L353.4 32 352 32l0 112zM128 299.2c33.8-61.5 92.1-108.2 162.9-126.2c2.2 10.6 5.5 20.9 9.9 30.5C200.2 228.2 128 318.7 128 424l0 56 48 0 128 0c0 0 0 0 0 0l48 0 0-5.3c0-14.7-11.9-26.7-26.7-26.7L288 448l-16 0 0-16 0-16 0-24c0-22.1-17.9-40-40-40l-8 0-16 0 0-32 16 0 8 0c39.8 0 72 32.2 72 72l0 7.3 118.2-91.9L448 287.3l0 32.7 0 160 32 0 0-200.2c11.4-4 22.1-9.4 32-16.1L512 496l0 16-16 0-64 0-16 0 0-16 0-143.3-82.2 63.9c28.4 4.1 50.2 28.5 50.2 58.1l0 21.3 0 16-16 0-64 0-128 0c0 0 0 0 0 0l-64 0-16 0 0-16 0-72 0-248c0-26.5-21.5-48-48-48l-16 0 0-32 16 0c44.2 0 80 35.8 80 80l0 123.2zM384 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;